import script from "./ParticipantIdModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParticipantIdModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__